import { ViewResolver } from '@Components/ViewResolver';
import { PaginationSettings } from './desktop/type';
import ConfirmationDesktopLayout from './desktop/ConfirmationDesktopLayout';
import ConfirmationMobileLayout from './mobile/ConfirmationMobileLayout';

interface ConfirmationProps {
  backToText?: string;
  caption?: string;
  actions?: JSX.Element | null;
  content?: JSX.Element | null;
  paginationSettings?: PaginationSettings;
  hidePagination?: boolean;
  handleBack: () => void;
  handleCancel: () => void;
  handleConfirm: () => void;
}

const Confirmation: React.FC<ConfirmationProps> = (props) => {
  return (
    <ViewResolver
      desktop={<ConfirmationDesktopLayout {...props} />}
      mobile={<ConfirmationMobileLayout {...props} />}
    />
  );
};

export default Confirmation;
